import { useEffect } from "react";
import { Link } from "react-router-dom";
import "@/pages/ThankYou.css";

export default function ThankYou() {
  useEffect(() => {
    document.title = "Thank you — Ōraṇi";
    window.scrollTo(0, 0);
  }, []);

  return (
    <main
      className="thankyou"
      data-testid="thankyou-root"
      aria-label="Enquiry received"
    >
      <section className="thankyou__inner">
        <span className="thankyou__eyebrow" data-testid="thankyou-eyebrow">
          Enquiry received
        </span>
        <h1 className="thankyou__title" data-testid="thankyou-title">
          Thank you for writing to us.
        </h1>
        <div className="thankyou__body" data-testid="thankyou-body">
          <p>We&rsquo;ve received your enquiry.</p>
          <p>
            We are a small studio and review every note personally. You can
            expect to hear from us within 2&ndash;3 working days.
          </p>
        </div>

        <Link to="/work" className="thankyou__cta" data-testid="thankyou-cta">
          <span>Continue exploring our work</span>
          <span className="thankyou__cta-arrow" aria-hidden="true">&rarr;</span>
          <span className="thankyou__cta-rule" aria-hidden="true" />
        </Link>
      </section>
    </main>
  );
}
